"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dynamicListingsTool = void 0;
const zod_1 = require("zod");
exports.dynamicListingsTool = {
    name: 'dynamicListings',
    description: `This tool signals the frontend to display a dynamic listings panel when a specific condition is met.

    The triggering condition and available listings are provided in the system message as:
    <tool-data toolName="dynamicListings">
      <tool-data-entry key="conditionPrompt">CONDITION_DESCRIPTION</tool-data-entry>
      <tool-data-entry key="listingsData">JSON_LISTINGS_ARRAY</tool-data-entry>
    </tool-data>

    WHEN TO CALL THIS TOOL:
    - Read the value of <tool-data-entry key="conditionPrompt"> to learn when to trigger this tool.
    - If the user's message satisfies that condition, call this tool immediately.

    SELECTING WHICH LISTINGS TO INCLUDE (selectedOfferIds):
    - Parse the JSON array in <tool-data-entry key="listingsData"> to understand every available listing.
    - Each listing has an "offer_id" field and an "attributes" array of objects with "label", "value", and "type" fields.
    - Cross-reference the content of all attribute values (text, numbers, booleans) with the current conversation context.
    - Only include the offer_id values of listings whose attributes are relevant to what the user is talking about.
      Examples:
        • User mentions "Chicago" → only include listings whose attributes contain "Chicago" or related location data.
        • User asks about "sea view" → only include listings that have attributes mentioning sea, ocean, or beach.
        • User asks about "cheapest" → only include the listing(s) with the lowest price attribute value.
        • User's message is generic or no listing is specifically more relevant than another → include ALL offer_ids.
    - NEVER include an offer_id that does not exist in listingsData.
    - If the conversation context does not match ANY listing specifically, pass all offer_ids (do not filter).

    IMPORTANT: After calling this tool, you MUST continue with a normal conversational response.
    The tool runs in the background — it does not replace your reply.

    Examples:
    - conditionPrompt: "signal listings when user writes 'whats up brother'"
      User writes "whats up brother", listings have offers in Paris and Berlin, no location context → call with all offer_ids AND respond normally.
    - conditionPrompt: "show offers when user asks about hotels"
      User asks "do you have hotels in Chicago?", listings contain "Chicago" attribute on OFF-003 only
      → call with selectedOfferIds: ["OFF-003"] AND describe the Chicago hotel.
    - conditionPrompt: "show offers when user asks about price"
      User asks "what's the cheapest?" → call with the offer_id that has the lowest price value AND explain the price.
    `,
    zodSchema: zod_1.z.object({
        selectedOfferIds: zod_1.z
            .array(zod_1.z.string().describe('offer_id of a contextually relevant listing (e.g. "OFF-001"). Must exist in listingsData.'))
            .describe('Offer IDs that are relevant to the current conversation context. Include ALL offer_ids when no specific filtering applies.')
    }),
    blockStream: false
};
